import React from 'react';
import { ArrowRight, Shield } from 'lucide-react';

const HeroSection = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  const scrollToServices = () => {
    const element = document.getElementById('services');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="min-h-screen flex items-center justify-center pt-20" 
      style={{ background: 'var(--gradient-hero-warm)' }}>
      <div className="container-custom py-20">
        <div className="max-w-4xl mx-auto text-center">
          {/* Announcement Badge */}
          <div className="inline-flex items-center gap-2 bg-white/40 backdrop-blur-sm rounded-full px-4 py-2 mb-6">
            <Shield className="w-4 h-4 text-[var(--brand-blue)]" />
            <span className="text-xs font-medium text-[var(--text-primary)] uppercase tracking-wide">
              Trusted Healthcare Support Partner
            </span>
          </div>

          {/* Main Headline */}
          <h1 className="heading-hero mb-6">
            Reducing Healthcare Financial Burden,<br />
            <span className="text-[var(--brand-blue)]">One Claim at a Time</span>
          </h1>

          {/* Subtitle */}
          <p className="body-large text-[var(--text-secondary)] mb-8 max-w-2xl mx-auto">
            We help hospitals and patients manage treatment access and insurance-claim journeys, while reducing out-of-pocket expenses through our comprehensive support services.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button onClick={scrollToContact} className="btn-primary w-full sm:w-auto">
              Get Started
              <ArrowRight className="w-4 h-4 ml-2" />
            </button>
            <button onClick={scrollToServices} className="btn-secondary w-full sm:w-auto">
              Learn More
            </button>
          </div>

          {/* Trust Indicators */}
          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white/60 backdrop-blur-sm rounded-xl p-6">
              <div className="heading-2 text-[var(--brand-blue)] mb-2">Cashless Desk</div>
              <p className="body-small text-[var(--text-secondary)]">Management</p>
            </div>
            <div className="bg-white/60 backdrop-blur-sm rounded-xl p-6">
              <div className="heading-2 text-[var(--brand-green)] mb-2">Reimbursement</div>
              <p className="body-small text-[var(--text-secondary)]">Financing Support</p>
            </div>
            <div className="bg-white/60 backdrop-blur-sm rounded-xl p-6">
              <div className="heading-2 text-[var(--brand-blue)] mb-2">Patient</div>
              <p className="body-small text-[var(--text-secondary)]">Assistance Programs</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
